import { render, staticRenderFns } from "./Convenios.vue?vue&type=template&id=16715524&scoped=true"
import script from "./Convenios.vue?vue&type=script&lang=js"
export * from "./Convenios.vue?vue&type=script&lang=js"
import style0 from "./Convenios.vue?vue&type=style&index=0&id=16715524&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16715524",
  null
  
)

export default component.exports